// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aviso-sem-agendamento[data-v-1ee50841]{text-align:center;font-size:1.6em;font-family:Lato}.btn-disabled[data-v-1ee50841]{cursor:not-allowed;opacity:.5}", ""]);
// Exports
module.exports = exports;
